import axios, { getEnv } from './api';

const pushService = {
  buscarPushs: async (mapParams, filters) => {
    try {
      const res = await axios.post(
        `${await getEnv(
          'REACT_APP_URL_SERVICE'
        )}/v1/notificacoes/consultar${mapParams}`,
        filters
      );
      return res;
    } catch (error) {
      return error;
    }
  },
  getOptions: async (isOptimized = false) => {
    try {
      const res = await axios.get(
        `${await getEnv(
          'REACT_APP_URL_SERVICE'
        )}/v1/notificacoes/opcoes?consulta=${isOptimized}`
      );
      return res;
    } catch (error) {
      return error;
    }
  },
  saveImage: async (formData) => {
    try {
      const res = await axios.post(
        `${await getEnv('REACT_APP_URL_SERVICE')}/v1/minio/upload`,
        formData,
        {
          headers: {
            'content-type': 'multipart/form-data',
          },
        }
      );
      return res;
    } catch (error) {
      return error;
    }
  },
  savePush: async (notificacao) => {
    try {
      const res = await axios.post(
        `${await getEnv('REACT_APP_URL_SERVICE')}/v1/notificacoes`,
        notificacao
      );
      return res;
    } catch (error) {
      return error;
    }
  },
  deletePush: async (idNotificacao) => {
    try {
      const res = await axios.delete(
        `${await getEnv(
          'REACT_APP_URL_SERVICE'
        )}/v1/notificacoes/${idNotificacao}`
      );
      return res;
    } catch (error) {
      return error;
    }
  },
  sendPush: async (idNotificacao) => {
    try {
      const res = await axios.get(
        `${await getEnv(
          'REACT_APP_URL_SERVICE'
        )}/v1/notificacoes/${idNotificacao}/enviar`
      );
      return res;
    } catch (error) {
      return error;
    }
  },
  updateStatus: async (idNotificacao, status) => {
    try {
      const res = await axios.put(
        `${await getEnv(
          'REACT_APP_URL_SERVICE'
        )}/v1/notificacoes/${idNotificacao}/status/${status}`
      );
      return res;
    } catch (error) {
      return error;
    }
  },
  updatePush: async (notificacao) => {
    try {
      const res = await axios.put(
        `${await getEnv('REACT_APP_URL_SERVICE')}/v1/notificacoes`,
        notificacao
      );
      return res;
    } catch (error) {
      return error;
    }
  },
  getAmountByStatus: async (status) => {
    try {
      const res = await axios.get(
        `${await getEnv(
          'REACT_APP_URL_SERVICE'
        )}/v1/notificacoes/quantidade/status/${status}`
      );
      return res;
    } catch (error) {
      return error;
    }
  },
};

export default pushService;
